import React, { useEffect } from "react";
import styles from "../../styles/pages/games/Modal.module.scss";

export default function Modal({ open, title, children, onClose }) {
  useEffect(() => {
    if (!open) return;
    const onKey = e => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className={styles.backdrop} role="dialog" aria-modal="true" aria-label={title}>
      <div className={styles.sheet}>
        <div className={styles.topbar}>
          <h2 className={styles.title}>{title}</h2>
          <button className={styles.close} onClick={onClose} aria-label="Close">✕</button>
        </div>
        <div className={styles.content}>{children}</div>
      </div>
      <button className={styles.scrim} onClick={onClose} aria-label="Close" />
    </div>
  );
}
